import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { initAuth } from '@/lib/auth'
import { initCountries } from '@/lib/countries'

// Order matters: tokens first, then element defaults, then the handful of
// global styles this app adds — the shapes that pages opt into with a class
// rather than import. Everything else is scoped to its component.
import '@/styles/tokens.css'
import '@/styles/base.css'
import '@/styles/page.css'
import '@/styles/table.css'
import '@/styles/form.css'

// Kick the session restore off before the first navigation is resolved.
void initAuth()
// Reference data, fetched once and shared. Public, so it does not wait for the
// session, and nothing blocks on it — the country control reports its own
// failure rather than holding up the app. Amenity labels need no equivalent:
// they are compiled in, not fetched. See lib/amenities.ts.
void initCountries()

createApp(App).use(router).mount('#app')
